import React from 'react';

interface WelcomeStepProps {
  onNext: () => void;
}

export const WelcomeStep: React.FC<WelcomeStepProps> = ({ onNext }) => {
  return (
    <div className="flex flex-col items-center space-y-6 sm:space-y-8 text-center">
      <h2 className="text-2xl sm:text-3xl font-bold text-white">Welcome!</h2>
      <p className="text-base sm:text-lg text-gray-300 font-bold">
        We're about to map out your 3-year vision. This will take less than 2 minutes and will help NuroLeap become the bridge to your dream life.
      </p>
      <button
        onClick={onNext}
        onTouchEnd={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onNext();
        }}
        className="bg-gradient-to-br from-[#79c9cb] to-[#4b7bdd] text-black py-3 sm:py-4 px-6 sm:px-8 rounded-3xl font-semibold hover:opacity-90 transition-opacity mb-1 text-base sm:text-base w-[80%] mx-auto block touch-manipulation"
        style={{ touchAction: 'manipulation' }}
      >
        Get Started
      </button>
    </div>
  );
};